import { render } from "./STFMFM02C16FileUploadComfirm.vue?vue&type=template&id=491096bf&scoped=true"
import script from "./STFMFM02C16FileUploadComfirm.vue?vue&type=script&lang=js"
export * from "./STFMFM02C16FileUploadComfirm.vue?vue&type=script&lang=js"

import "./STFMFM02C16FileUploadComfirm.vue?vue&type=style&index=0&id=491096bf&scoped=true&lang=css"

import exportComponent from "D:\\TDS\\40_製造(M)\\99_電帳法_USE\\Tatsuzin_filemanage\\vue\\tdsvue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491096bf"]])

export default __exports__